<template>
	<div ref="scrollContainer" id="page-po" v-loading="loading" class="scrollable only-y">
    <el-row>
      <el-col style="padding-left:10px;">
        <ReservationView @close="closeSelectedReservation" @edit="editReservation" :reservation="this.selectedReservation"></ReservationView>
      </el-col>
    </el-row>
    <ReservationEditor :visible="reservationEditorVisible" :edit="selectedReservation" @close="closeReservationEditor"></ReservationEditor>
	</div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import ReservationEditor from '@/components/reservation/reservation-editor'
import ReservationView from './components/reservation-view'

export default {
  data() {
    return {
      reservationEditorVisible : false,
			editSelectedReservation: null
    };
  },components: {
    ReservationEditor,
		ReservationView
  },
	methods: {
		openSalesOrderEditor(){
			this.openEditInvoiceDialog();
		},
		closeSelectedReservation(){
			var index='/reservations';
			this.$router.push(index);
		},
		editReservation(){
			this.reservationEditorVisible=true;
		},
		closeReservationEditor(){
			this.reservationEditorVisible=false;
			this.editSelectedReservation=null;
		},
		...mapActions('reservations', [ 'selectReservation']),
	},
	computed: {
		reservationId(){
			return this.$route.params.reservationId;
		},
		...mapState('reservations',['loading','selectedReservation'])
	},
  mounted(){

  },
	created(){

		this.selectReservation({reservationId : this.reservationId, index:null});
	}
}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:80px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}

.el-table tr, .el-table__row{
  background-color: #f3f7fa;
}


@media (max-width: 1024px) {
  img.inventory {
    margin-top:20px;
    height:175px;
  }
}
</style>
